import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { logout } from "../../worker-auth/slice/workerAuthSlice";
import { getInfo } from "../slice/workerInfoSlice";

const WorkerSidebar = () => {
  // const isVerified = 1;
  const isVerified = useSelector(
    (state) => state.workerInfo.userData?.is_verify === 1
  );
  const isCompliance = useSelector(
    (state) => state.workerInfo.userData?.is_compliance === 1
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [openJobBoard, setOpenJobBoard] = useState(false);
  const [openJobShift, setOpenJobShift] = useState(false);
  const token = localStorage.getItem("token");
  // const [userData, setUserData] = useState(null);
  const { userData, loading } = useSelector(
    (state) => state.workerInfo
  );

  useEffect(() => {
    if (!token) return;

    dispatch(getInfo(token));
  }, [token, dispatch]);

  const jobBoardKeys = [
    "add-job",
    "my-job",
    "resume-list",
    "add-resume",
    "job-by-type",
    // "job-by-experience",
    "job-by-categories",
    "job-by-states",
    "skills-by-resume",
    "job-applications",
    // "job-shift-applications",
    "apply-jobs",
    "assigned-shift-job-details",
    // "providers-employees"
  ];

  const jobShiftKeys = [
    "add-shift-job",
    "shift-jobs",
    "shift-job-request",
    "assigned-shift-jobs",
    "assigned-shift-job-details",
    "add-worktime",
    "accepted-jobs",
    // "providers-employees"
  ];


  const sidebarRouteMap = {
    "my-job": ["/panel/my-job", "/panel/edit-job"],
    "shift-jobs": ["/panel/shift-jobs", "/panel/shift-job-details", "/panel/edit-shift-job"],
    "resume-list": ["/panel/resume-list", "/panel/resume-details", "/panel/edit-resume"],
    "add-job": ["/panel/add-job"],
    "add-shift-job": ["/panel/add-shift-job"],
    "add-resume": ["/panel/add-resume"],
    "job-by-type": ["/panel/job-by-type"],
    // "job-by-experience": ["/panel/job-by-experience"],
    "skills-by-resume": ["/panel/skills-by-resume"],
    "job-applications": ["/panel/job-applications"],
    // "job-shift-applications": ["/panel/job-shift-applications"],
    "apply-jobs": ["/panel/apply-job"],
    "shift-job-request": ["/panel/shift-job-request"],
    "job-by-categories": ["/panel/job-by-categories"],
    "job-by-states": ["/panel/job-by-states"],
    "assigned-shift-jobs": ["/panel/assigned-shift-jobs", "/panel/assigned-shift-job-details"],
    "add-worktime": ["/panel/add-worktime"],
    "accepted-jobs": ["/panel/accepted-jobs"],
    "benefit-boundary-setup": ["panel/benefit-boundary-setup"]
    // "providers-employees": ["/panel/providers-employees"]
  };

  const isSidebarItemActive = (key) => {
    return sidebarRouteMap[key]?.some((path) =>
      location.pathname.startsWith(path)
    );
  };

  const location = useLocation();

  useEffect(() => {
    const isJobBoardActive = jobBoardKeys.some((key) =>
      isSidebarItemActive(key)
    );

    const isJobShiftActive = jobShiftKeys.some((key) =>
      isSidebarItemActive(key)
    );

    setOpenJobBoard(isJobBoardActive);
    setOpenJobShift(isJobShiftActive);
  }, [location.pathname]);



  if (loading || !userData) {
    return (
      <div className="col-md-4 col-xl-3 sidebar">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  const { role_id } = userData;

  const hideCompliance = [4, 5, 6].includes(role_id);
  const isJobRole = role_id === 3;
  const isResumeRole = [4, 5, 6].includes(role_id);
  const isComplianceRole = [5, 6].includes(role_id);

  const jobBoardChildren = [
    ...(isJobRole
      ? [
        { to: "add-job", label: "Add New Job" },
        // { to: "add-shift-job", label: "Add Shift Job" },
        { to: "my-job", label: "My Job" },
        // { to: "shift-jobs", label: "Shift Jobs" },
        { to: "skills-by-resume", label: "Resume By Skills" },
        { to: "job-applications", label: "Job Applications" },
        // { to: "job-shift-applications", label: "Shift Job Applications" },
      ]
      : []),

    ...(isResumeRole
      ? [
        // { to: "shift-job-request", label: "Job Requests" },
        { to: "resume-list", label: "Resume List" },
        { to: "add-resume", label: "Add Resume" },
        { to: "job-by-type", label: "Job By Type" },
        // { to: "job-by-experience", label: "Job By Experience" },
        { to: "job-by-categories", label: "Job By Categories" },
        { to: "job-by-states", label: "Job By States" },
        { to: "apply-jobs", label: "Applied Jobs" },
      ]
      : []),

  ];

  const jobShiftChildren = [
    ...(isJobRole
      ? [
        { to: "add-shift-job", label: "Add Shift Request" },
        { to: "shift-jobs", label: "My Shift Requests" },
        { to: "assigned-shift-jobs", label: "Assigned Shift Request" },
      ]
      : []),

    ...(isResumeRole
      ? [
        { to: "shift-job-request", label: "Shift Requests" },
        { to: "accepted-jobs", label: "Accepted Shift Requests" },
        // { to: "add-worktime", label: "Add Worktime" },
      ]
      : []),
  ];


  const verifiedLinks = [
    { to: "compliance", label: "Compliance" },
    { to: "download", label: "Download" },
    { to: "myplans", label: "My Subscription" },
    { to: "providers-employees", label: "My Employees" },
    { to: "provider-benefit-boundary-setup", label: "Benefits Readiness Setup" },
    // {
    //   type: "dropdown",
    //   label: "Job Board",
    //   children: jobBoardChildren,
    // },
    // {
    //   type: "dropdown",
    //   label: "Shift Request",
    //   children: jobShiftChildren,
    // },
    // { to: "add-worktime", label: "Worktime" },
    { to: "editprofile", label: "Edit Profile" },
  ];

  const baseLinks = [
    { to: "/panel", label: "Dashboard" },
  ];

  if (!isVerified) {
    baseLinks.push({ to: "verify", label: "Verify" });
  }

  const filteredVerifiedLinks = verifiedLinks.filter((link) => {
    if (link.type === "dropdown") {
      return link.children.length > 0;
    }
    if (link.to === "compliance" && !isComplianceRole) {
      return false;
    }

    if (link.to === "add-worktime" && !isResumeRole) {
      return false;
    }

    if (link.to === "download" && !isResumeRole) {
      return false;
    }

    if (link.to === "providers-employees" && !isJobRole) {
    return false;
  }

    return true;
  });


  // const links = [...baseLinks, ...(isVerified ? verifiedLinks : [])];

  const links = [...baseLinks, ...(isVerified ? filteredVerifiedLinks : [])];

  const handleWorkerLogout = () => {
    dispatch(logout());
    navigate("/signin");
  };

  const roleLabelMap = {
    3: "Provider",
    4: "Employee",
    5: "Teacher",
    6: "Support Staff",
  };

  return (
    <div className="col-md-4 col-xl-3 sidebar">
      <h4 className="font-weight-bold montserrat text-primary font-size-40 mb-4 pb-1 border-bottom pb-3 d-flex align-items-center">
        {roleLabelMap[role_id] || ""}
        {isVerified && (
          <>
            <svg width="60" height="55" viewBox="0 0 401 401" fill="none" xmlns="http://www.w3.org/2000/svg" className="ms-auto">
              <path d="M133.784 39.8494C109.913 46.4237 86.205 53.577 62.6814 61.3029C60.5318 61.9961 58.6208 63.2805 57.167 65.0091C55.7132 66.7377 54.7754 68.8406 54.4609 71.0772C40.5763 175.262 72.6563 251.277 110.927 301.352C127.123 322.771 146.444 341.636 168.245 357.316C176.916 363.431 184.585 367.842 190.626 370.674C193.633 372.095 196.081 373.08 197.969 373.632C198.801 373.884 199.646 374.094 200.5 374.258C201.346 374.093 202.182 373.884 203.006 373.632C204.911 373.064 207.367 372.078 210.375 370.674C216.39 367.842 224.084 363.406 232.756 357.316C254.556 341.636 273.877 322.771 290.074 301.352C328.344 251.302 360.424 175.262 346.539 71.0772C346.225 68.8406 345.287 66.7377 343.833 65.0091C342.38 63.2805 340.468 61.9961 338.319 61.3029C322.003 55.9646 294.459 47.2679 267.217 39.8744C239.397 32.3306 213.808 26.7417 200.5 26.7417C187.217 26.7417 161.603 32.3056 133.784 39.8494ZM127.117 14.035C154.31 6.64156 183.207 0 200.5 0C217.793 0 246.69 6.64156 273.883 14.035C301.703 21.5538 329.747 30.4509 346.239 35.8394C353.133 38.1163 359.246 42.2921 363.875 47.8869C368.503 53.4818 371.459 60.2688 372.404 67.4682C387.341 179.673 352.68 262.83 310.625 317.843C292.784 341.37 271.521 362.092 247.542 379.321C239.26 385.297 230.471 390.538 221.277 394.985C214.259 398.293 206.716 401 200.5 401C194.285 401 186.766 398.293 179.723 394.985C170.529 390.538 161.74 385.297 153.458 379.321C129.479 362.092 108.216 341.37 90.3755 317.843C48.3206 262.83 13.6592 179.673 28.5964 67.4682C29.541 60.2688 32.4973 53.4818 37.1256 47.8869C41.754 42.2921 47.8668 38.1163 54.7617 35.8394C78.7028 27.995 102.828 20.7248 127.117 14.035Z" fill="#002B45" />
              <path d="M272.2 204.682C273.367 205.846 274.293 207.228 274.925 208.751C275.557 210.273 275.882 211.905 275.882 213.554C275.882 215.202 275.557 216.834 274.925 218.356C274.293 219.879 273.367 221.262 272.2 222.426L197.013 297.613C195.849 298.78 194.466 299.706 192.944 300.338C191.421 300.97 189.789 301.295 188.141 301.295C186.493 301.295 184.86 300.97 183.338 300.338C181.816 299.706 180.433 298.78 179.269 297.613L141.675 260.02C140.51 258.854 139.586 257.471 138.955 255.949C138.325 254.427 138 252.795 138 251.147C138 249.5 138.325 247.868 138.955 246.346C139.586 244.824 140.51 243.44 141.675 242.275C142.84 241.11 144.223 240.186 145.746 239.555C147.268 238.925 148.899 238.6 150.547 238.6C152.195 238.6 153.826 238.925 155.349 239.555C156.871 240.186 158.254 241.11 159.419 242.275L188.141 271.022L254.456 204.682C255.62 203.515 257.003 202.589 258.526 201.957C260.048 201.325 261.68 201 263.328 201C264.977 201 266.609 201.325 268.131 201.957C269.654 202.589 271.036 203.515 272.2 204.682Z" fill="#002B45" />
              <path d="M81.2614 125.364L85.0966 156.131H85.4375L99.5 125.364H112.881L91.233 169H75.0398L67.8807 125.364H81.2614ZM109.839 169L117.083 125.364H148.532L146.913 134.909H127.311L126.118 142.409H144.1L142.481 151.955H124.498L123.305 159.455H142.822L141.203 169H109.839ZM147.163 169L154.408 125.364H173.243C176.482 125.364 179.216 125.953 181.446 127.132C183.676 128.311 185.281 130.009 186.261 132.224C187.241 134.44 187.476 137.097 186.964 140.193C186.453 143.318 185.324 145.953 183.577 148.098C181.844 150.229 179.635 151.848 176.95 152.956C174.28 154.05 171.283 154.597 167.959 154.597H156.709L158.243 145.392H167.107C168.499 145.392 169.72 145.222 170.771 144.881C171.822 144.526 172.675 143.972 173.328 143.219C173.982 142.452 174.408 141.443 174.607 140.193C174.805 138.943 174.706 137.928 174.308 137.146C173.911 136.351 173.25 135.768 172.327 135.399C171.403 135.016 170.26 134.824 168.896 134.824H164.72L159.01 169H147.163ZM176.055 148.972L183.641 169H170.771L163.442 148.972H176.055ZM206.918 125.364L199.674 169H187.827L195.072 125.364L206.918 125.364ZM205.288 169L212.533 125.364H243.214L241.595 134.909H222.76L221.567 142.409H238.527L236.908 151.955H219.947L217.135 169H205.288ZM259.418 125.364L252.174 169H240.327L247.572 125.364H259.418ZM257.788 169L265.033 125.364H296.482L294.862 134.909H275.26L274.067 142.409H292.05L290.43 151.955H272.447L271.254 159.455H290.771L289.152 169H257.788ZM312.158 169H295.113L302.357 125.364H318.721C323.209 125.364 326.959 126.266 329.971 128.07C332.982 129.874 335.12 132.452 336.384 135.804C337.648 139.156 337.897 143.148 337.13 147.778C336.391 152.239 334.892 156.053 332.634 159.22C330.39 162.388 327.52 164.81 324.026 166.486C320.546 168.162 316.59 169 312.158 169ZM308.621 158.943H312.925C315.084 158.943 317.009 158.567 318.699 157.814C320.404 157.047 321.824 155.768 322.961 153.979C324.111 152.175 324.942 149.71 325.453 146.585C325.936 143.631 325.922 141.351 325.411 139.746C324.9 138.126 323.926 137.004 322.492 136.379C321.057 135.74 319.203 135.42 316.931 135.42H312.542L308.621 158.943Z" fill="#002B45" />
            </svg>
          </>
        )}
        {isCompliance && (
          <>
            <svg width="60" height="55" viewBox="0 0 401 401" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M133.784 39.8494C109.913 46.4237 86.205 53.577 62.6814 61.3029C60.5318 61.9961 58.6208 63.2805 57.167 65.0091C55.7132 66.7377 54.7754 68.8406 54.4609 71.0772C40.5763 175.262 72.6563 251.277 110.927 301.352C127.123 322.771 146.444 341.636 168.245 357.316C176.916 363.431 184.585 367.842 190.626 370.674C193.633 372.095 196.081 373.08 197.969 373.632C198.801 373.884 199.646 374.094 200.5 374.258C201.346 374.093 202.182 373.884 203.006 373.632C204.911 373.064 207.367 372.078 210.375 370.674C216.39 367.842 224.084 363.406 232.756 357.316C254.556 341.636 273.877 322.771 290.074 301.352C328.344 251.302 360.424 175.262 346.539 71.0772C346.225 68.8406 345.287 66.7377 343.833 65.0091C342.38 63.2805 340.468 61.9961 338.319 61.3029C322.003 55.9646 294.459 47.2679 267.217 39.8744C239.397 32.3306 213.808 26.7417 200.5 26.7417C187.217 26.7417 161.603 32.3056 133.784 39.8494ZM127.117 14.035C154.31 6.64156 183.207 0 200.5 0C217.793 0 246.69 6.64156 273.883 14.035C301.703 21.5538 329.747 30.4509 346.239 35.8394C353.133 38.1163 359.246 42.2921 363.875 47.8869C368.503 53.4818 371.459 60.2688 372.404 67.4682C387.341 179.673 352.68 262.83 310.625 317.843C292.784 341.37 271.521 362.092 247.542 379.321C239.26 385.297 230.471 390.538 221.277 394.985C214.259 398.293 206.716 401 200.5 401C194.285 401 186.766 398.293 179.723 394.985C170.529 390.538 161.74 385.297 153.458 379.321C129.479 362.092 108.216 341.37 90.3755 317.843C48.3206 262.83 13.6592 179.673 28.5964 67.4682C29.541 60.2688 32.4973 53.4818 37.1256 47.8869C41.754 42.2921 47.8668 38.1163 54.7617 35.8394C78.7028 27.995 102.828 20.7248 127.117 14.035Z" fill="#69B95E" />
              <path d="M272.029 128.972C273.196 130.136 274.121 131.518 274.753 133.041C275.385 134.563 275.71 136.195 275.71 137.844C275.71 139.492 275.385 141.124 274.753 142.647C274.121 144.169 273.196 145.552 272.029 146.716L196.841 221.903C195.677 223.07 194.294 223.996 192.772 224.628C191.249 225.26 189.617 225.585 187.969 225.585C186.321 225.585 184.689 225.26 183.166 224.628C181.644 223.996 180.261 223.07 179.097 221.903L141.503 184.31C140.338 183.144 139.414 181.761 138.783 180.239C138.153 178.717 137.828 177.085 137.828 175.437C137.828 173.79 138.153 172.158 138.783 170.636C139.414 169.114 140.338 167.73 141.503 166.565C142.668 165.4 144.051 164.476 145.574 163.845C147.096 163.215 148.728 162.89 150.375 162.89C152.023 162.89 153.654 163.215 155.177 163.845C156.699 164.476 158.082 165.4 159.247 166.565L187.969 195.312L254.284 128.972C255.448 127.805 256.831 126.879 258.354 126.247C259.876 125.615 261.508 125.29 263.156 125.29C264.805 125.29 266.437 125.615 267.959 126.247C269.482 126.879 270.865 127.805 272.029 128.972Z" fill="#69B95E" />
              <rect x="38" y="270" width="326" height="71" rx="27" fill="#002B45" />
              <path d="M92.1989 301.818H84.3011C84.358 301.146 84.3201 300.54 84.1875 300C84.0549 299.46 83.8277 298.996 83.5057 298.608C83.1837 298.21 82.7623 297.907 82.2415 297.699C81.7206 297.491 81.1004 297.386 80.3807 297.386C78.9981 297.386 77.7623 297.732 76.6733 298.423C75.5843 299.105 74.6799 300.085 73.9602 301.364C73.2405 302.633 72.7292 304.148 72.4261 305.909C72.161 307.614 72.1515 309.029 72.3977 310.156C72.6534 311.283 73.1506 312.126 73.8892 312.685C74.6373 313.243 75.608 313.523 76.8011 313.523C77.5966 313.523 78.3258 313.428 78.9886 313.239C79.661 313.049 80.2576 312.779 80.7784 312.429C81.3087 312.069 81.7585 311.643 82.1278 311.151C82.5066 310.649 82.7955 310.095 82.9943 309.489H90.9489C90.6458 310.72 90.1061 311.979 89.3295 313.267C88.553 314.545 87.5492 315.724 86.3182 316.804C85.0871 317.874 83.6383 318.741 81.9716 319.403C80.3049 320.066 78.4299 320.398 76.3466 320.398C73.6193 320.398 71.2661 319.801 69.2869 318.608C67.3172 317.415 65.8873 315.672 64.9972 313.381C64.1165 311.089 63.9413 308.295 64.4716 305C65.0019 301.818 66.0483 299.152 67.6108 297.003C69.1733 294.853 71.072 293.234 73.3068 292.145C75.5417 291.056 77.9186 290.511 80.4375 290.511C82.3409 290.511 84.0455 290.762 85.5511 291.264C87.0663 291.766 88.34 292.5 89.3722 293.466C90.4138 294.422 91.1809 295.601 91.6733 297.003C92.1657 298.404 92.3409 300.009 92.1989 301.818ZM123.31 305.966C122.78 309.129 121.729 311.78 120.157 313.92C118.585 316.061 116.677 317.675 114.433 318.764C112.188 319.853 109.788 320.398 107.231 320.398C104.504 320.398 102.136 319.806 100.129 318.622C98.121 317.438 96.6579 315.705 95.7393 313.423C94.8208 311.141 94.6361 308.352 95.1854 305.057C95.6967 301.894 96.7384 299.233 98.3104 297.074C99.8823 294.915 101.8 293.281 104.063 292.173C106.326 291.065 108.746 290.511 111.322 290.511C114.03 290.511 116.383 291.108 118.381 292.301C120.389 293.494 121.847 295.241 122.756 297.543C123.675 299.844 123.86 302.652 123.31 305.966ZM115.356 305.057C115.621 303.39 115.64 301.989 115.413 300.852C115.185 299.706 114.707 298.845 113.978 298.267C113.249 297.68 112.269 297.386 111.038 297.386C109.636 297.386 108.396 297.727 107.316 298.409C106.237 299.091 105.342 300.071 104.631 301.349C103.921 302.628 103.424 304.167 103.14 305.966C102.837 307.652 102.808 309.053 103.055 310.17C103.31 311.288 103.812 312.126 104.56 312.685C105.318 313.243 106.303 313.523 107.515 313.523C108.897 313.523 110.119 313.191 111.18 312.528C112.25 311.866 113.135 310.904 113.836 309.645C114.546 308.385 115.053 306.856 115.356 305.057ZM129.464 290.909H139.294L143.328 307.386H143.669L153.158 290.909H162.987L158.158 320H150.43L153.214 303.182H152.987L143.783 319.773H139.124L135.43 303.068H135.203L132.362 320H124.635L129.464 290.909ZM161.901 320L166.73 290.909H179.287C181.446 290.909 183.264 291.335 184.741 292.188C186.219 293.04 187.279 294.238 187.923 295.781C188.567 297.325 188.719 299.129 188.378 301.193C188.037 303.295 187.279 305.109 186.105 306.634C184.94 308.149 183.454 309.318 181.645 310.142C179.846 310.956 177.829 311.364 175.594 311.364H168.094L169.116 305.227H175.026C175.973 305.227 176.806 305.066 177.526 304.744C178.245 304.413 178.828 303.949 179.273 303.352C179.718 302.746 180.007 302.027 180.139 301.193C180.272 300.36 180.21 299.65 179.955 299.062C179.708 298.466 179.282 298.011 178.676 297.699C178.08 297.377 177.317 297.216 176.389 297.216H173.605L169.798 320H161.901ZM188.151 320L192.98 290.909H200.878L197.128 313.636H208.889L207.81 320H188.151ZM223.729 290.909L218.9 320H211.002L215.832 290.909H223.729ZM230.2 320H221.677L236.109 290.909H246.904L251.677 320H243.154L240.313 298.92H240.086L230.2 320ZM230.54 308.523H246.563L245.54 314.432H229.518L230.54 308.523ZM284.479 290.909L279.649 320H273.058L265.104 304.716H264.933L262.376 320H254.479L259.308 290.909H266.013L273.854 306.136H274.081L276.581 290.909H284.479ZM313.527 301.818H305.629C305.686 301.146 305.648 300.54 305.516 300C305.383 299.46 305.156 298.996 304.834 298.608C304.512 298.21 304.09 297.907 303.57 297.699C303.049 297.491 302.429 297.386 301.709 297.386C300.326 297.386 299.09 297.732 298.001 298.423C296.912 299.105 296.008 300.085 295.288 301.364C294.569 302.633 294.057 304.148 293.754 305.909C293.489 307.614 293.48 309.029 293.726 310.156C293.982 311.283 294.479 312.126 295.217 312.685C295.965 313.243 296.936 313.523 298.129 313.523C298.925 313.523 299.654 313.428 300.317 313.239C300.989 313.049 301.586 312.779 302.107 312.429C302.637 312.069 303.087 311.643 303.456 311.151C303.835 310.649 304.124 310.095 304.322 309.489H312.277C311.974 310.72 311.434 311.979 310.658 313.267C309.881 314.545 308.877 315.724 307.646 316.804C306.415 317.874 304.966 318.741 303.3 319.403C301.633 320.066 299.758 320.398 297.675 320.398C294.947 320.398 292.594 319.801 290.615 318.608C288.645 317.415 287.215 315.672 286.325 313.381C285.445 311.089 285.269 308.295 285.8 305C286.33 301.818 287.376 299.152 288.939 297.003C290.501 294.853 292.4 293.234 294.635 292.145C296.87 291.056 299.247 290.511 301.766 290.511C303.669 290.511 305.374 290.762 306.879 291.264C308.394 291.766 309.668 292.5 310.7 293.466C311.742 294.422 312.509 295.601 313.001 297.003C313.494 298.404 313.669 300.009 313.527 301.818ZM314.127 320L318.957 290.909H339.923L338.843 297.273H325.775L324.979 302.273H336.968L335.888 308.636H323.9L323.104 313.636H336.116L335.036 320H314.127Z" fill="white" />
            </svg>
          </>
        )}
      </h4>

      <nav className="nav flex-column">
        {links.map((link, index) => {
          if (link.type === "dropdown") {
            const isJobBoard = link.label === "Job Board";
            const isOpen = isJobBoard ? openJobBoard : openJobShift;
            return (
              <div key={index} className="dropdown-container">

                {/* MAIN DROPDOWN BUTTON */}
                <button
                  type="button"
                  className="nav-link btn w-100 text-start d-flex justify-content-between align-items-center text-white"
                  onClick={() => {
                    if (link.label === "Job Board") {
                      setOpenJobBoard(!openJobBoard);
                    } else {
                      setOpenJobShift(!openJobShift);
                    }
                  }}

                  style={{
                    textDecoration: "none",
                    fontWeight: "400",
                    background: "transparent",
                    border: "none",
                    backgroundColor: "rgb(105 177 144)"
                  }}
                >
                  {link.label}

                  {/* Arrow with rotation */}
                  <span
                    style={{
                      display: "inline-block",
                      transition: "0.3s",
                      transform: isOpen ? "rotate(180deg)" : "rotate(0deg)"
                    }}
                  >
                    ▼
                  </span>
                </button>

                {/* CHILD LINKS */}
                {isOpen && (
                  <div className="ms-3">
                    {link.children.map((child) => (
                      <NavLink
                        key={child.to}
                        to={child.to}
                        className={() =>
                          `nav-link${isSidebarItemActive(child.to) ? " active" : ""}`
                        }
                      >
                        {child.label}
                      </NavLink>

                    ))}
                  </div>
                )}
              </div>
            );
          }

          // Normal single links
          return (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.to === "/panel"}   // 👈 only dashboard should match exact
              className={({ isActive }) =>
                `nav-link${isActive ? " active" : ""}`
              }
            >
              {link.label}
            </NavLink>
          );
        })}

        {/* LOGOUT BUTTON */}
        <button
          onClick={handleWorkerLogout}
          className="nav-link btn btn-link text-start"
          style={{ textDecoration: "none", fontWeight: "400" }}
        >
          Logout
        </button>
      </nav>
    </div>
  );
};

export default WorkerSidebar;
